import { Switch, Route, Redirect } from 'react-router-dom';
import { useUserAuth } from '../state/userAuthContext';
import { accountRoutes } from './allRoutes';

const switchRoutes = (
  <Switch>
    {accountRoutes.map((prop, key) => {
      if (prop.layout === 'account') {
        return <Route path={`/${prop.layout}${prop.path}`} component={prop.component} key={key} exact />;
      }
      return null;
    })}
    <Redirect from="/account" to="/account/details" />
  </Switch>
);

const Account = () => {
  const { user } = useUserAuth();
  return <> {user && switchRoutes} </>;
};

export default Account;
